export default {

  // заполняем хранилище
  set data(loadedData) {
    localStorage.setItem('name', loadedData.nickname);
    // localStorage.setItem('lastLogin', loadedData.lastLogin);
    localStorage.setItem('email', loadedData.email);
    // localStorage.setItem('directory', loadedData.directory);
    localStorage.setItem('operatorId', loadedData.id);
    localStorage.setItem('tokenFestBuilder', loadedData.token);
    localStorage.setItem('permissionsOnFest', loadedData.permissionsOnFest);

    // localStorage.setItem('currentFestival', loadedData.currentFestival);
    // localStorage.setItem('currentBusiness', loadedData.current_business);
    // localStorage.setItem('currentStock', loadedData.current_stock);
  },

  // возвращаем данные
  get data() {
    return {
      nickname: localStorage.getItem('nickname'),
     // lastLogin: localStorage.getItem('lastLogin'),
     // directory: localStorage.getItem('directory'),
      email: localStorage.getItem('email'),
      operatorId: localStorage.getItem('operatorId'),
      token: localStorage.getItem('tokenFestBuilder'),
      permissionsOnFest: localStorage.getItem('permissionsOnFest')
      // currentFestival: localStorage.getItem('currentFestival'),
      // currentBusiness: localStorage.getItem('currentBusiness'),
      // currentStock: localStorage.getItem('currentStock'),
    };
  },

  // отдельные сеттеры для бизнеса и склада
  set currentFestival(id) {
    localStorage.setItem('currentFestival', id);
  },
  get currentFestival() {
    return localStorage.getItem('currentFestival');
  },
  set currentStock(id) {
    localStorage.setItem('currentStock', id);
  },

  // работа с правами доступа
  set currentScreen(screen) {
    sessionStorage.setItem('currentScreen', screen);
  },

  get currentScreen() {
    return sessionStorage.getItem('currentScreen');
  },

  set permissions(data) {
    // localStorage.setItem('permissions', data.map((item) => item.kod_operation).join());
  },

  get permissions() {
    return localStorage.getItem('permissions');
  },

  // проверка хранилища
  get isSetFlag() {
    return Object.values(this.data).some((item) => item !== null);
  },

  // чистим хранилище
  clean() {
    localStorage.removeItem('nickname');
    // localStorage.removeItem('lastLogin');
   // localStorage.removeItem('directory');
    localStorage.removeItem('email');
    localStorage.removeItem('operatorId');
    localStorage.removeItem('tokenFestBuilder');
    localStorage.removeItem('currentFestival'),
    localStorage.removeItem('currentBusiness');
    localStorage.removeItem('operatorIdFestBuilder');
    localStorage.removeItem('permissionsOnFest');
  },

  // ВСЯКОЕ ПРОЧЕЕ


  set currentStockName(name) {
    sessionStorage.setItem('currentStockName', name);
  },

  get currentStockName() {
    return sessionStorage.getItem('currentStockName');
  },

  set currentContractorId(id) {
    sessionStorage.setItem('currentContractorId', id);
  },

  get currentContractorId() {
    return sessionStorage.getItem('currentContractorId');
  },

  set currentContractorType(type) {
    sessionStorage.setItem('currentContractorType', type);
  },

  get currentContractorType() {
    return sessionStorage.getItem('currentContractorType');
  },

  set currentContractorOperation(type) {
    sessionStorage.setItem('currentContractorOperation', type);
  },

  get currentContractorOperation() {
    return sessionStorage.getItem('currentContractorOperation');
  },

  set currentUserId(id) {
    sessionStorage.setItem('currentUserId', id);
  },

  get currentUserId() {
    return sessionStorage.getItem('currentUserId');
  },

  set currentOperatorId(id) {
    sessionStorage.setItem('operatorId', id);
  },

  get currentOperatorId() {
    return sessionStorage.getItem('operatorId');
  },



  set permissionsOnFest(per) {
    localStorage.setItem('permissionsOnFest', per);
  },

  get permissionsOnFest() {
    return localStorage.getItem('permissionsOnFest');
  },

  set allDocsOperationType(type) {
    sessionStorage.setItem('allDocsOperationType', type);
  },

  get allDocsOperationType() {
    return sessionStorage.getItem('allDocsOperationType');
  },

  set currentBillId(id) {
    sessionStorage.setItem('currentBillId', id);
  },

  get currentBillId() {
    return sessionStorage.getItem('currentBillId');
  },

  set currentUserStatus(type) {
    sessionStorage.setItem('currentUserStatus', type);
  },

  get currentUserStatus() {
    return sessionStorage.getItem('currentUserStatus');
  },



};
